// global
import { adminDataStore, triggersStore } from "../../store/Store"

// components
import DisplayList from "../../components/DisplayList"



export default function AdminCompanies() {
  // global
  const adminCompanyData = adminDataStore((data) => data.adminCompanyData);
  const setAdminCompanyData = adminDataStore((data) => data.setAdminCompanyData);
  const adminCompanyTrigger = triggersStore((data) => data.adminCompanyTrigger)
  const setAdminCompanyTrigger = triggersStore((data) => data.setAdminCompanyTrigger)

  return (
    <div className='conatiner-fluid'>
      <DisplayList 
        coll={'Admin Companies'}
        docs={adminCompanyData}
        trigger={adminCompanyTrigger}
        setTrigger={setAdminCompanyTrigger}
        url={`${process.env.REACT_APP_BACKEND}/admin/companies`}
        setState={setAdminCompanyData}
        statusToggle={true}
      />
    </div>
  )
}